import { render } from "./LicenseChangeView.vue?vue&type=template&id=767620d5"
import script from "./LicenseChangeView.vue?vue&type=script&lang=js"
export * from "./LicenseChangeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__